import axios from 'axios'
import store from '../store'
import router from '../router'

function load () {
  axios.defaults.baseURL = process.env.API_HOST
  axios.defaults.headers.common['Content-Type'] = 'application/json'
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

  axios.interceptors.request.use(function (config) {
    store.commit('UI/hideSnackbar')

    return config
  }, function (error) {
    return Promise.reject(error)
  })

  axios.interceptors.response.use(function (response) {
    if (response.data.message) {
      store.commit('UI/showSnackbar', {
        color: 'success',
        text: response.data.message
      })
    }

    return response
  }, function (error) {
    if (!error.response) {
      store.commit('UI/showSnackbar', {
        color: 'error',
        text: 'Não foi possível contatar o servidor.'
      })
    } else if (error.response.status === 403) {
      store.dispatch('Auth/removeCurrentUser')
      router.replace({
        name: 'Login'
      })
    } else if (error.response.data.message) {
      store.commit('UI/showSnackbar', {
        color: 'error',
        text: error.response.data.message
      })
    } else {
      store.commit('UI/showSnackbar', {
        color: 'error',
        text: 'Falha ao prosseguir com sua solicitação. Por favor, contate o webmaster.'
      })
    }

    return Promise.reject(error)
  })
}

export default { load }



// WEBPACK FOOTER //
// ./src/config/axios.js